/* FiveRiyal storefront behaviour: hero slider, AJAX add-to-cart, toast, newsletter */
(function () {
  'use strict';

  /* ---- toast ---- */
  let toastEl;
  function toast(html, ms) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fr-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), ms || 4500);
  }

  /* ---- cart count ---- */
  function setCartCount(n) {
    document.querySelectorAll('.fr-cart-count').forEach((el) => {
      el.textContent = n > 0 ? n : '';
      el.dataset.count = n;
    });
  }
  function refreshCartCount() {
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => setCartCount(c.item_count))
      .catch(() => {});
  }

  /* ---- add to cart (product cards) ---- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.fr-card__form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.fr-card__add');
    const label = btn ? btn.querySelector('.fr-card__add-label') : null;
    const original = label ? label.textContent : '';
    if (btn) btn.classList.add('is-loading');
    const fd = new FormData(form);
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) throw new Error(j.description || j.message || 'error');
        refreshCartCount();
        // let the theme's cart drawer (if enabled) refresh itself
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (btn) {
          btn.classList.add('is-done');
          if (label) label.textContent = form.dataset.addedText || 'Added';
          setTimeout(() => {
            btn.classList.remove('is-done');
            if (label) label.textContent = original;
          }, 1800);
        }
        const cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        toast((form.dataset.addedText || 'Added to cart') + ' <a href="' + cartUrl + '">' + (form.dataset.viewCartText || 'View cart') + ' →</a>');
      })
      .catch((err) => toast(err.message || 'Could not add to cart'))
      .finally(() => btn && btn.classList.remove('is-loading'));
  });

  /* ---- hero slider ---- */
  document.querySelectorAll('.fr-hero').forEach((hero) => {
    const slides = hero.querySelectorAll('.fr-hero__slide');
    const dots = hero.querySelectorAll('.fr-hero__dot');
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    const go = (n) => {
      slides[i].classList.remove('is-active');
      dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      dots[i] && dots[i].classList.add('is-active');
    };
    const start = () => {
      const speed = parseInt(hero.dataset.autoplay || '0', 10);
      if (speed > 0) timer = setInterval(() => go(i + 1), speed * 1000);
    };
    dots.forEach((d, n) => d.addEventListener('click', () => { clearInterval(timer); go(n); start(); }));
    start();
  });

  /* ---- newsletter ---- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.fr-news__form');
    if (!form) return;
    // Let Shopify handle the customer form normally; just add a loading state.
    const btn = form.querySelector('button');
    if (btn) btn.classList.add('is-loading');
  });

  /* ---- mobile menu ---- */
  document.querySelectorAll('.fr-header__burger').forEach((b) => {
    b.addEventListener('click', () => {
      const panel = b.closest('.fr-header').querySelector('.fr-mobile-menu');
      if (panel) panel.toggleAttribute('open');
    });
  });

  window.frToast = toast;
  document.addEventListener('DOMContentLoaded', refreshCartCount);
})();
